module.exports = __webpack_public_path__ + "static/media/MUSEA_Logo_2026.4869535f.png";